import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { IntellisenseCoreModule } from '@blaze-shared/intellisense-feature';
import { SelectComponent } from '@blaze-shared/shared-feature';
import { CheckboxComponent, TooltipDirective } from '@blaze-shared/shared-ui';
import { IconsModule } from '@blaze-shared/theming-data-access';

import { ComparisonQueryRowComponent } from './components/comparison-query-row/comparison-query-row.component';
import { ComplexFilterComponent } from './components/complex-filter/complex-filter.component';
import { LogicalQueryRowComponent } from './components/logical-query-row/logical-query-row.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TooltipDirective,
    MatSlideToggleModule,
    IconsModule,
    IntellisenseCoreModule,
    DragDropModule,
    CheckboxComponent,
    ComparisonQueryRowComponent,
    ComplexFilterComponent,
    LogicalQueryRowComponent,
    SelectComponent,
  ],
})
export class ComplexFiltersModule {}
